import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import 'bootstrap/dist/css/bootstrap.min.css';
import '@fortawesome/fontawesome-free/css/all.min.css';

import { BrowserRouter } from 'react-router-dom'; // ✅ Add this

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <BrowserRouter basename="/clms"> {/* ✅ Wrap App in BrowserRouter */}
    <App />
  </BrowserRouter>
  //   <BrowserRouter > {/* ✅ Wrap App in BrowserRouter */}
  //   <App />
  // </BrowserRouter>
);

reportWebVitals();
